import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { observable, action, computed, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';
import Spinner from "./Spinner";
import { SelectInput } from './Form';
import { pagination } from '../libs/localStorage';

@inject('rolePermissionStore')
@observer
class DataTable extends Component {

  // @observable checkedAll = false;
  // @observable checkedRows = {};
  @observable data = [];
  @observable prevSortKey = null;
  @observable prevSortOrder = 1;
  @observable pagination = {
    page: 0,
    size: pagination.get(),
    options: [
      { size: 25 },
      { size: 50 },
      { size: 100 },
      { size: 200 },
      { size: 1000 }
    ]
  };
  @observable search = {};

  @computed get totalPages() {
    return Math.ceil(this.filteredData.length / this.pagination.size);
  }

  @computed get filteredData() {
    let search = toJS(this.search);
    return this.data.filter(item => Object.keys(search).reduce((acc, key) => {
      let value = _.result(item, key, '');
      return (
        acc && (search[key] === '' || (typeof value === 'string' ? value : _.result(value, 'props.children', '')).toString().toLowerCase().indexOf(search[key].toString().toLowerCase()) > -1)
      )
    }, true));
  }

  constructor(props) {
    super(props);

    this.state = {
      checkedAll: false,
      checkedRows: {},
      // data: [],
      // prevSortKey: null,
      // prevSortOrder: 1,
    };

    this.onChangeHeaderCheckbox = this.onChangeHeaderCheckbox.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderRow = this.renderRow.bind(this);
    this.onClickDeleteMultiple = this.handleDeleteMultiple.bind(this);
    this.onClickSelectMultiple = this.handleSelectMultiple.bind(this);
  }

  componentWillMount() {
    const { checkedIds = [], data, sortRow } = this.props;
    const checkedRows = checkedIds.reduce((acc, id) => {
      return Object.assign({}, acc, {
        [id]: true,
      });
    }, {});

    this.setState({
      checkedRows,
      // data: data,
    });
    // this.checkedRows = checkedRows;
    this.data = sortRow ? sortRow(data) : data.sort((a, b) => +a.id < +b.id ? -1 : 1);
    this.sortColumn = this.sortColumn.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sortRow } = this.props;
    const { data } = nextProps;
    // const { prevSortKey, prevSortOrder, data: prevFilteredData } = this.state;
    // const prevSortKey = this.prevSortKey;
    // const prevSortOrder = this.prevSortOrder;
    // const prevFilteredData = this.data;

    // const diff = _.difference(data, prevFilteredData)
    // .reduce((acc, cur) => {
    // return { ...acc, [cur.id]: cur };
    // }, {});

    // const data = prevFilteredData.map(item => {
    // return diff[item.id] || item;
    // });

    // this.setState({
    // data,
    // });
    const prevSortKey = this.prevSortKey || 'id';
    const prevSortOrder = this.prevSortOrder || 1;
    this.data = sortRow ? sortRow(data) : data.sort((a, b) => +a[prevSortKey] < +b[prevSortKey] ? -prevSortOrder : prevSortOrder);
  }

  onChangeHeaderCheckbox() {
    const { data } = this.props;

    const checkedRows = this.state.checkedRows;
    const checkedAll = !this.state.checkedAll;

    // const checkedRows = this.checkedRows;
    // const checkedAll = !this.checkedAll;

    data.forEach(row => {
      checkedRows[row.id] = checkedAll;
    });

    this.setState({
      checkedAll,
      checkedRows,
    });

    // this.checkedAll = checkedAll;
    // this.checkedRows = checkedRows;
  }

  onChangeRowCheckbox(id) {
    const { checkedRows } = this.state;
    // const checkedRows = this.checkedRows;
    const checkedRow = checkedRows[id] || false;

    checkedRows[id] = !checkedRow;

    // this.checkedRows = checkedRows;
    this.setState({
      checkedRows,
    });
  }

  handleSelectMultiple() {
    const { checkedRows } = this.state;
    // const checkedRows = this.checkedRows;
    const checkedRowIds = Object.keys(checkedRows)
      .filter(key => checkedRows[key])
      .map(key => +key);
    if (this.props.onMultiSelect && this.props.onMultiSelect) {
      this.props.onMultiSelect(checkedRowIds);
    }
  }

  handleDeleteMultiple() {
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (!confirm('Delete?')) { return; }
    const { checkedRows } = this.state;
    // const checkedRows = this.checkedRows;
    const checkedRowIds = Object.keys(checkedRows)
      .filter(key => checkedRows[key])
      .map(key => +key);
    if (this.props.allowDelete && this.props.onDelete) {
      this.props.onDelete(checkedRowIds);
    }
  }

  handleDeleteSingle(id) {
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (!this.props.noDeletePrompt && !confirm('Delete?')) { return; }
    if (this.props.allowDelete && this.props.onDelete) {
      this.props.onDelete(id);
    }
  }

  @action
  sortColumn(sortKey) {
    // const { prevSortKey, prevSortOrder } = this.state;
    const prevSortKey = this.prevSortKey;
    const prevSortOrder = this.prevSortOrder;

    const { data } = this.props;
    const sortOrder = (sortKey === prevSortKey) ? -prevSortOrder : prevSortOrder;

    const selectedColumn = this.props.columns.find(col => col.key === sortKey);

    const sortedData = data
      .sort((a, b) => {
        if (selectedColumn && selectedColumn.value) {
          if (a[selectedColumn.value] === b[selectedColumn.value]) { return 1; }
          return a[selectedColumn.value] > b[selectedColumn.value] ? sortOrder : -sortOrder;
        } else {
          if (a[sortKey] === b[sortKey]) { return 1; }
          return a[sortKey] > b[sortKey] ? sortOrder : -sortOrder;
        }
      });

    // this.setState({
    // data,
    // prevSortKey: sortKey,
    // prevSortOrder: sortOrder,
    // });
    this.data = sortedData;
    this.prevSortKey = sortKey;
    this.prevSortOrder = sortOrder;
  }

  renderSearch() {
    const { columns, actions, allowEdit, allowDelete, allowAdd, onSelect } = this.props;
    const noSearchableColumns = !columns.filter(item => item.searchable).length;
    if (noSearchableColumns) return;

    return (
      <tbody>
        <tr>
          <th />
          {columns.map(({ key, label, searchable }) => (
            <th key={key}>
              {searchable ? <input placeholder={label} onChange={e => { this.search = Object.assign({}, toJS(this.search), { [key]: e.target.value }); this.pagination.page = 0 }} style={{ width: '70%' }} /> : ''}
            </th>
          ))}
          {onSelect && <th>{''}</th>}
          {actions && <th>{''}</th>}
          {(allowAdd || allowEdit) && <th className="crudActions" />}
          {allowDelete && <th className="crudActions" />}
        </tr>
      </tbody>
    );
  }

  renderHeader() {
    const {
      columns,
      slug,
      actions,
      showSerialNo,
      allowAdd,
      allowEdit,
      allowDelete,
      disableMultipleDelete,
      onSelect,
      rolePermissionStore,
      resource,
      centered,
      renderButtons,
    } = this.props;
    // const { checkedAll, prevSortOrder: sortOrder, prevSortKey: sortKey } = this.state;
    const checkedAll = this.checkedAll;
    const sortOrder = this.prevSortOrder;
    const prevSortKey = this.prevSortKey;

    return (
      <tr>
        <th>
          {allowDelete && !disableMultipleDelete && rolePermissionStore.validateRole(`modify ${resource}`) && (
            <input
              type="checkbox"
              onChange={this.onChangeHeaderCheckbox}
              checked={checkedAll}
            />
          )}
        </th>
        {showSerialNo && <th>S.No.</th>}
        {columns.map(({ key, sortKey, label, sortable }) => (
          <th key={key} onClick={sortable && this.sortColumn.bind(this, sortKey || key)} style={centered ? { textAlign: 'center' } : {}}>
            {label}
            {sortable && (key !== prevSortKey) && (
              <i className="fa fa-sort white" aria-hidden="true" style={{ fontSize: '11px' }} />
            )}
            {sortable && (key === prevSortKey) && sortOrder === 1 && (
              <i className="fa fa-sort-down white" aria-hidden="true" style={{ fontSize: '11px' }} />
            )}
            {sortable && (key === prevSortKey) && sortOrder === -1 && (
              <i className="fa fa-sort-up white" aria-hidden="true" style={{ fontSize: '11px' }} />
            )}
          </th>
        ))}
        {onSelect && (
          <th>{''}</th>
        )}
        {actions && (
          <th>{''}</th>
        )}
        {renderButtons && (
          <th>{''}</th>
        )}
        {(allowAdd || allowEdit) ? (
          <th className="crudActions">
            {allowAdd && rolePermissionStore.validateRole(`modify ${resource}`) && (
              <Link to={`/${slug}/add`}>
                <i className="fa fa-plus white" aria-hidden="true" />
              </Link>
            )}
          </th>
        ) : <td />}
        <th className="crudActions">
          {allowDelete && !disableMultipleDelete && rolePermissionStore.validateRole(`modify ${resource}`) && (
            <a onClick={this.onClickDeleteMultiple}>
              <i className="fa fa-trash-o white" aria-hidden="true" />
            </a>
          )}
        </th>
      </tr>
    );
  }

  renderRow(rowData, index) {
    const { showSerialNo, columns, slug, parentSlug, actions, allowAdd, allowEdit, allowDelete, disableMultipleDelete, onSelect, renderChild, rolePermissionStore, resource, renderButtons, centered } = this.props;
    const { checkedRows } = this.state;
    // const checkedRows = this.checkedRows;
    const { id, station_id } = rowData;
    const checked = checkedRows[id] || false;

    const onChangeRowCheckbox = this.onChangeRowCheckbox.bind(this, id);
    const onClickDelete = this.handleDeleteSingle.bind(this, id || station_id);
    const handleSelect = () => {
      if (parentSlug) {
        this.context.router.push(parentSlug);
        return;
      }
      this.context.router.push(slug);
    };

    const colSpan = (allowDelete ? 0 : 1) +
      (allowAdd || allowEdit || allowDelete ? 0 : 1) +
      columns.length +
      (handleSelect ? 1 : 0) +
      (actions ? actions.length : 0);

    return (
      <tbody key={id || index}>
        <tr ref={rowData.highlight ? (e) => e ? e.scrollIntoView({ behavior: "smooth", block: "center", inline: 'center' }) : null : null} className={rowData.highlight ? 'row-highlight' : ''}>
          <td>
            {allowDelete && !disableMultipleDelete && rolePermissionStore.validateRole(`modify ${resource}`) && (
              <input
                type="checkbox"
                checked={checked}
                onChange={onChangeRowCheckbox}
              />
            )}
          </td>
          {showSerialNo && <td>{+index + 1}</td>}
          {columns.map(({ key, tooltip, options }) => (
            <td key={key} data-toogle="tooltop" title={tooltip && _.result(rowData, tooltip)} style={centered ? { textAlign: 'center' } : {}}>
              {!(options && options.type) && _.result(rowData, key)}
              {options && options.type && (
                <input
                  type={options.type}
                  value={_.result(rowData, key)}
                  onChange={options.onChange && options.onChange.bind(this, id)}
                  max={options.max}
                  min={options.min}
                />
              )}
            </td>
          ))}
          {onSelect && (
            <td>
              <div key={`select-${rowData.id}`} className="action">
                <a onClick={typeof onSelect === 'function' ? () => onSelect(rowData) : handleSelect}>Select</a>
              </div>
            </td>
          )}
          {renderButtons && (
            <td>
              {renderButtons(rowData)}
            </td>
          )}
          {actions && (
            <td>
              {actions.map(({ label, link }) => (
                <div key={label} className="action">
                  <Link to={link.replace('{id}', id || station_id)}>
                    {label}
                  </Link>
                </div>
              ))}
            </td>
          )}
          {(allowAdd || allowEdit) ? (
            <td className="crudActions">
              {allowEdit && rolePermissionStore.validateRole(`modify ${resource}`) && (
                <Link to={`/${slug}/${id || station_id}`}>
                  <i className="fa fa-pencil" aria-hidden="true" />
                </Link>
              )}
            </td>
          ) : <td />}
          {(allowDelete) && rolePermissionStore.validateRole(`modify ${resource}`) ? (
            <td className="crudActions">
              {allowDelete && (
                <a onClick={onClickDelete}>
                  <i className="fa fa-trash" aria-hidden="true" />
                </a>
              )}
            </td>
          ) : <td />}
        </tr>
        {renderChild && (
          <tr className="childRow">
            <td colSpan={colSpan}>
              {this.props.renderChild(rowData)}
            </td>
          </tr>
        )}
      </tbody>
    );
  }

  _renderTablePagination = () => {
    return (
      <div className='inline-grid v-center' style={{ gap: 0 }}>
        <div className='inline-grid v-center'>
          <label>Pagination</label>
          <SelectInput id='pagination' label="" fields={{ label: 'size', value: 'size' }} value={this.pagination.size} options={this.pagination.options} sortOptions={(a, b) => a.size - b.size} onChange={e => { this.pagination.size = e.target.value; this.pagination.page = 0; pagination.set(e.target.value); }} small />
        </div>
        <span className='flex-grow' />
        <div className='v-center'>
          <span className='button button-inactive' onClick={() => this.pagination.page = 0} ><i className="fa fa-angle-double-left" /></span>
          <span className='button button-inactive' onClick={() => this.pagination.page != 0 && this.pagination.page--} ><i className="fa fa-angle-left" /></span>
          <b style={{ margin: '0 8px' }}>{this.pagination.page + 1} of {this.totalPages}</b>
          <span className='button button-inactive' onClick={() => this.pagination.page != this.totalPages - 1 && this.pagination.page++} ><i className="fa fa-angle-right" /></span>
          <span className='button button-inactive' onClick={() => this.pagination.page = this.totalPages - 1} ><i className="fa fa-angle-double-right" /></span>
        </div>
      </div>
    )
  }

  render() {
    const { caption, onMultiSelect, isLoading, paginate, searchable, stickyHeader } = this.props;
    const data = !paginate || this.filteredData.length <= 25 ? this.filteredData : this.filteredData.slice(this.pagination.page * this.pagination.size, (this.pagination.page + 1) * this.pagination.size);

    return (
      <div>
        {!!paginate && this.filteredData.length > 25 && this._renderTablePagination()}
        <div style={ stickyHeader ? {overflow:''} :{overflowX:'auto'}} >
          <div className={'DataTable'}  >
            <table>{caption && (<caption>{caption}</caption>)}</table>
            <table style={stickyHeader ? {overflow:''} : {overflow:'hidden'}}>
              <thead style={{ position: "sticky", top: "0"}}>
                {this.renderHeader()}
              </thead>
              {this.renderSearch()}
              {data && (data.map(this.renderRow))}
            </table>
            {onMultiSelect && (
              <div className="tableActions">
                <button onClick={this.onClickSelectMultiple}>Select</button>
              </div>
            )}
          </div>
          </div>
        {isLoading && <Spinner />}
      </div>
    );
  }
}

DataTable.wrappedComponent.defaultProps = {
  allowAdd: false,
  allowEdit: false,
  allowDelete: false,
  data: [],
  paginate: true,
};

DataTable.wrappedComponent.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.shape().isRequired,
    PropTypes.array.isRequired,
  ]).isRequired,
  slug: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  actions: PropTypes.array,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func,
  renderButtons: PropTypes.func,
  renderChild: PropTypes.func,
  caption: PropTypes.string,
  allowAdd: PropTypes.bool,
  allowEdit: PropTypes.bool,
  allowDelete: PropTypes.bool,
  disableMultipleDelete: PropTypes.bool,
};

DataTable.wrappedComponent.contextTypes = {
  router: PropTypes.shape().isRequired,
};

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/DataTable.js